import { $admin } from "./api/admin";
import apiEndpoints from "@/constants/api-endpoints";

/**
 * Fetches list of error logs 
 * @param {Object} params Request query params
 * @returns {Promise} List of error logs
 */
export const errorLogs = (params) => {
  return $admin.get(`${apiEndpoints.errors}`, { params });
};
